import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// El service worker del panel se registra acá y no inyectado en el HTML (vite.config.ts, injectRegister: false): así
// /cotizaciones/, que no carga este archivo, no se baja el precache del panel. Es la misma llamada que hacía el
// registerSW.js inyectado, al terminar de cargar. NO se usa registerSW de virtual:pwa-register: con registerType
// 'autoUpdate' recarga la pestaña apenas se activa una versión nueva, sin mirar si hay algo escrito, y se saltaría el
// seguro de iniciarVigilanciaDeVersion (src/lib/actualizacionDeVersion.ts). En desarrollo no hay service worker.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {});
  });
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('No se encontró el elemento #root');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
